import { QueryHookOptions } from '@apollo/react-hooks'

import { SortDirection } from '@app/graphql/types'
import {
  CourtCasesQuery,
  CourtCasesQueryVariables,
  useCourtCasesQuery
} from '@app/queries/CourtCases/CourtCases.queries'

export const getCoveredCourtCasesVariables = (customerId: number): CourtCasesQueryVariables => ({
  filters: {
    customerId: { equals: customerId },
    isCovered: { equals: true }
  },
  sorts: {
    createdAt: SortDirection.Desc
  }
})

export const useCoveredCourtCasesQuery = (
  customerId: number,
  options?: Omit<QueryHookOptions<CourtCasesQuery, CourtCasesQueryVariables>, 'variables'>
) =>
  useCourtCasesQuery({
    fetchPolicy: 'network-only',
    ...options,
    variables: getCoveredCourtCasesVariables(customerId)
  })
